import ValueDeserializerInterface from "./ValueDeserializerInterface"
import { SerializedValueType } from "../../Model/Value/ValueInterface"
import FactorialValue from "../../Model/Value/FactorialValue"
import GameDeserializer from "../GameDeserializer"

export default class FactorialValueDeserializer implements ValueDeserializerInterface {
  private serializer: GameDeserializer | undefined = undefined

  public deserialize(payload: SerializedValueType): FactorialValue {
    if (this.serializer === undefined) {
      throw new Error("FactorialValueDeserializer requires serializer value")
    }

    return new FactorialValue(
      this.serializer.deserializeValue(
        payload.payload.base as SerializedValueType,
      ),
    )
  }

  public supports(payload: SerializedValueType): boolean {
    return payload.type === "factorial"
  }

  public setSerializer(serializer: GameDeserializer) {
    this.serializer = serializer
  }
}
